import { Box, Typography } from "@mui/material";
import type { ReactNode } from "react";

type Props = {
  label: string;
  value: ReactNode;
};

export const DataRow = ({ label, value }: Props) => (
  <Box display="flex" gap={1}>
    <Typography flexShrink={0}>{label}</Typography>
    <Box
      flex={1}
      minWidth={0}
      display="flex"
      justifyContent="flex-end"
      alignItems="center"
    >
      {typeof value === "string" || !value ? (
        <Typography
          fontWeight={500}
          textAlign="right"
          sx={{ overflowWrap: "anywhere" }}
        >
          {value ?? "-"}
        </Typography>
      ) : (
        <Box sx={{ fontWeight: 500 }}>{value}</Box>
      )}
    </Box>
  </Box>
);
